export const THEMES = [
  'defaultDark',
  'kidsDark',
] as const;
export const THEME_COOKIE = 'tubi-theme';
